export enum SmartFieldPermissions {
    CAN_EDIT = 'client_optional',
    MUST_FILL = 'client_required',
    CANT_EDIT = 'vendor_required'
}

export interface SmartFieldDropdownOptionGroup {
    label: string;
    value?: string;
    isSubLabelGreyed?: boolean;
    subLabel?: string;
    options?: SmartFieldDropdownOption[];
    data?: {
        data_source_property: string;
        data_source_sub_property: string;
        data_source_type: string;
    };
}

export type SmartFieldDropdownOption = Omit<
    SmartFieldDropdownOptionGroup,
    'options'
>;
